'use strict';

import ProductDetails from '../product-details/product-details';

export default class ProductsList {
    constructor() {
        let isGridView = true;

        // Init Products
        let productDetails = new ProductDetails();

        $('.js-grid-view').on('click', function (e) {
            e.preventDefault();

            isGridView = true;

            let $this = $(this),
                $parent = $this.parent();

            $parent.find('.active').removeClass();
            $this.addClass('active');
            $this.closest('.layout-selection').next().removeClass('list-view');

        });

        $('.js-list-view').on('click', function (e) {
            e.preventDefault();

            isGridView = false;

            let $this = $(this),
                $parent = $this.parent();

            $parent.find('.active').removeClass();
            $this.addClass('active');
            $this.closest('.layout-selection').next().addClass('list-view');

        });

        $('.js-switch-phases').on('click', function (e) {
            e.preventDefault();

            let $this = $(this),
                $btnWrapper = $this.parent(),
                $phaseContainer = $('.phase--container'),
                ind = $this.index() + 1;

            $btnWrapper.find('.active').removeClass('active');
            $this.addClass('active');

            $phaseContainer
                .find('.active').removeClass('active').end()
                .find('.phase--wrapper:nth-child(' + ind + ')').addClass('active');

            productDetails.updateProducts();
        });

        $('.categories-list__action').on('click', function (e){
            let $this = $(this),
                $list = $this.siblings('.categories-list');

                $this.toggleClass('expande');

                $list.slideToggle({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
        });
    }
}
